import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast } from "@hooks"
import {isLoadingCommonFilters, isSystemBusy, userID} from "@signals"
import { tableData } from "../@signals"


export default function useReport() {

    const { showToast } = useToast()
	const isLoadingTableData = useSignal(false)

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			isLoadingTableData.value = true
			postSubmit(`${WEBBACK_V2_API}/reports/data`, {
				userID: userID.value
			}).then(res => {
				tableData.value = res.data
				isLoadingTableData.value = false
			}).catch(e => {
				isSystemBusy.value = true
				tableData.value = []
			})
		}
	}, [isLoadingCommonFilters.value])

	return {
		isLoadingTableData: isLoadingTableData.value,
	}
}